import React, { useEffect, useState } from 'react'
import './Loaders.scss'

export const Spinner = ({
  className = '',
  size = '',
  color = '',
  themeColor = '',
  linear,
  ...props
}) => {
  const [alertReader, setAlertReader] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setAlertReader(true)
    }, 5000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <div
      role="status"
      aria-live={alertReader ? 'assertive' : undefined}
      aria-label={alertReader ? 'Loading' : undefined}
      className={`orbit-loader ${className} ${size} ${themeColor} ${linear ? 'linear' : ''}`}
      {...props}
    >
      <div className="top" style={{ background: color }} />
      <div className="right" style={{ background: color }} />
      <div className="bottom" style={{ background: color }} />
      <div className="left" style={{ background: color }} />
    </div>
  )
}
